import { SKILL_ICON } from "@/components/display/display-icon/artifacts";
import { useMatchRoute } from "@tanstack/react-router";
import { KitMenuTemplate } from "../KitMenuTemplate";
import { SETTINGS_GROUP_PARTIAL } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const SkillCreatorMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupSlug,
  kit,
}) => {
  const matchRoute = useMatchRoute();
  const groups = [
    {
      title: "Skill",
      icon: SKILL_ICON,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/skill",
        params: { groupSlug, kitUuid: kit.uuid },
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/skill" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/skill-settings",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/skill-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return <KitMenuTemplate kit={kit} groups={groups} mode={mode} />;
};
